import * as actionTypes from '@/store/action-types'
import * as getTypes from '@/store/get-types'
import * as mutationTypes from '@/store/mutation-types'

const state = {
  disclaimers: []
}

const getters = {
  [getTypes.APP_GET_DISCLAIMERS]: state => state.disclaimers
}
const actions = {
  [actionTypes.APP_SET_DISCLAIMER] (context, disclaimer) {
    context.commit(mutationTypes.APP_SET_DISCLAIMER, disclaimer)
  }
}

const mutations = {
  [mutationTypes.APP_SET_DISCLAIMER] (state, disclaimer) {
    if (!state.disclaimers.includes(disclaimer)) {
      state.disclaimers.push(disclaimer)
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
